export const videos = [
  {
    id: 'v001',
    title: '京都岚山樱花隧道4K实拍',
    slug: 'kyoto-arashiyama-sakura-tunnel-4k',
    categoryId: 'riben',
    categoryName: '日本樱花',
    thumbnail: 'https://readdy.ai/api/search-image?query=Kyoto%20Arashiyama%20bamboo%20grove%20with%20cherry%20blossom%20tunnel%2C%20pink%20sakura%20trees%20lining%20path%2C%20traditional%20Japanese%20scenery%2C%20serene%20atmosphere%2C%20cinematic%20video%20thumbnail%20style&width=640&height=360&seq=vid-001&orientation=landscape',
    duration: '03:24',
    resolution: '4K (3840×2160)',
    views: 32800,
    date: '2026-03-20',
    featured: true,
  },
  {
    id: 'v002',
    title: '武汉大学樱花大道航拍全景',
    slug: 'wuhan-university-sakura-aerial',
    categoryId: 'wuhan',
    categoryName: '武汉樱花',
    thumbnail: 'https://readdy.ai/api/search-image?query=Aerial%20view%20of%20Wuhan%20University%20campus%20with%20cherry%20blossom%20avenue%2C%20pink%20trees%20surrounding%20historic%20buildings%2C%20drone%20photography%2C%20spring%20season&width=640&height=360&seq=vid-002&orientation=landscape',
    duration: '02:48',
    resolution: '4K (3840×2160)',
    views: 25600,
    date: '2026-03-18',
    featured: true,
  },
  {
    id: 'v003',
    title: '樱花飘落慢动作特写：樱吹雪',
    slug: 'sakura-falling-slow-motion',
    categoryId: 'piaoluo',
    categoryName: '樱花飘落',
    thumbnail: 'https://readdy.ai/api/search-image?query=Slow%20motion%20closeup%20of%20pink%20cherry%20blossom%20petals%20falling%2C%20cinematic%20macro%20shot%2C%20soft%20bokeh%20background%2C%20romantic%20dreamy%20mood%2C%20high%20speed%20camera&width=640&height=360&seq=vid-003&orientation=landscape',
    duration: '01:56',
    resolution: '4K (3840×2160)',
    views: 42100,
    date: '2026-03-22',
    featured: true,
  },
  {
    id: 'v004',
    title: '北京玉渊潭樱花节晨光实拍',
    slug: 'beijing-yuyuantan-morning-sakura',
    categoryId: 'beijing',
    categoryName: '北京樱花',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beijing%20Yuyuantan%20Park%20morning%20cherry%20blossom%2C%20golden%20sunrise%20light%20through%20pink%20trees%2C%20lake%20reflection%2C%20tranquil%20atmosphere%2C%20cinematic%20landscape&width=640&height=360&seq=vid-004&orientation=landscape',
    duration: '02:15',
    resolution: '1080P (1920×1080)',
    views: 18900,
    date: '2026-03-16',
    featured: false,
  },
  {
    id: 'v005',
    title: '樱花延时摄影：72小时花开花落',
    slug: 'sakura-72h-timelapse',
    categoryId: 'yanshi',
    categoryName: '延时摄影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cherry%20blossom%20time%20lapse%20from%20bud%20to%20full%20bloom%2C%20dramatic%20lighting%20changes%2C%20nature%20documentary%20style%2C%20pink%20flowers%20opening%20sequence&width=640&height=360&seq=vid-005&orientation=landscape',
    duration: '04:32',
    resolution: '4K (3840×2160)',
    views: 35600,
    date: '2026-03-19',
    featured: true,
  },
  {
    id: 'v006',
    title: '东京上野公园夜樱点灯美景',
    slug: 'tokyo-ueno-night-sakura',
    categoryId: 'riben',
    categoryName: '日本樱花',
    thumbnail: 'https://readdy.ai/api/search-image?query=Tokyo%20Ueno%20Park%20night%20cherry%20blossom%20illumination%2C%20pink%20sakura%20trees%20lit%20by%20lanterns%2C%20romantic%20night%20atmosphere%2C%20Japanese%20festival%20vibe&width=640&height=360&seq=vid-006&orientation=landscape',
    duration: '02:08',
    resolution: '4K (3840×2160)',
    views: 29800,
    date: '2026-03-21',
    featured: false,
  },
  {
    id: 'v007',
    title: '武汉东湖磨山樱花园全景',
    slug: 'wuhan-east-lake-sakura-panorama',
    categoryId: 'wuhan',
    categoryName: '武汉樱花',
    thumbnail: 'https://readdy.ai/api/search-image?query=Wuhan%20East%20Lake%20Moshan%20cherry%20blossom%20garden%20panorama%2C%20thousands%20of%20pink%20trees%2C%20lake%20view%2C%20spring%20season%2C%20wide%20angle%20landscape&width=640&height=360&seq=vid-007&orientation=landscape',
    duration: '03:10',
    resolution: '1080P (1920×1080)',
    views: 21200,
    date: '2026-03-15',
    featured: false,
  },
  {
    id: 'v008',
    title: '樱花微距特写：露珠与花瓣4K',
    slug: 'sakura-macro-dewdrops-4k',
    categoryId: 'sucai',
    categoryName: '高清素材',
    thumbnail: 'https://readdy.ai/api/search-image?query=Extreme%20macro%20closeup%20of%20cherry%20blossom%20with%20morning%20dew%20drops%2C%20pink%20petals%20detail%2C%20shallow%20depth%20of%20field%2C%20nature%20photography%2C%20ultra%20HD&width=640&height=360&seq=vid-008&orientation=landscape',
    duration: '01:42',
    resolution: '4K (3840×2160)',
    views: 19500,
    date: '2026-03-14',
    featured: false,
  },
  {
    id: 'v009',
    title: '富士山下樱花与雪景同框',
    slug: 'mt-fuji-sakura-snow-scene',
    categoryId: 'riben',
    categoryName: '日本樱花',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mount%20Fuji%20with%20cherry%20blossom%20foreground%2C%20snow%20capped%20peak%2C%20pink%20sakura%20trees%2C%20iconic%20Japan%20landscape%2C%20clear%20spring%20day%2C%20travel%20photography&width=640&height=360&seq=vid-009&orientation=landscape',
    duration: '02:55',
    resolution: '4K (3840×2160)',
    views: 38700,
    date: '2026-03-23',
    featured: true,
  },
  {
    id: 'v010',
    title: '吉野山一目千本樱花盛景',
    slug: 'yoshino-mountain-sakura-spectacle',
    categoryId: 'riben',
    categoryName: '日本樱花',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mount%20Yoshino%20Japan%20cherry%20blossom%20panorama%2C%20thousands%20of%20pink%20trees%20covering%20mountain%20slopes%2C%20ancient%20temple%2C%20misty%20morning%2C%20breathtaking%20view&width=640&height=360&seq=vid-010&orientation=landscape',
    duration: '03:38',
    resolution: '4K (3840×2160)',
    views: 31200,
    date: '2026-03-24',
    featured: false,
  },
  {
    id: 'v011',
    title: '樱花雨中漫步：浪漫唯美氛围',
    slug: 'walking-in-sakura-rain',
    categoryId: 'piaoluo',
    categoryName: '樱花飘落',
    thumbnail: 'https://readdy.ai/api/search-image?query=Person%20walking%20under%20cherry%20blossom%20trees%20with%20petals%20falling%2C%20romantic%20spring%20scene%2C%20soft%20pastel%20colors%2C%20cinematic%20mood%2C%20dreamy%20atmosphere&width=640&height=360&seq=vid-011&orientation=landscape',
    duration: '02:20',
    resolution: '1080P (1920×1080)',
    views: 27400,
    date: '2026-03-17',
    featured: false,
  },
  {
    id: 'v012',
    title: '樱花延时摄影：日出到日落光影变幻',
    slug: 'sakura-sunrise-sunset-timelapse',
    categoryId: 'yanshi',
    categoryName: '延时摄影',
    thumbnail: 'https://readdy.ai/api/search-image?query=Sunrise%20to%20sunset%20time%20lapse%20of%20cherry%20blossom%20tree%2C%20dramatic%20sky%20color%20changes%2C%20golden%20hour%20to%20blue%20hour%2C%20nature%20cinematography&width=640&height=360&seq=vid-012&orientation=landscape',
    duration: '03:15',
    resolution: '4K (3840×2160)',
    views: 24300,
    date: '2026-03-13',
    featured: false,
  },
];